// ErrorBoundary.js - stops a single crash from blanking the whole app.
//
// Added Oct 2026 (Ali's report: pages sometimes came up completely blank on his
// phone and only a manual refresh fixed it). Before this, any error thrown while
// drawing a screen unmounted the entire React tree, which looks like an empty
// grey page. Now: the first time it happens we reload once automatically (that
// is what Ali was doing by hand), and if it happens again within a minute we
// show a friendly message with a Reload button instead of a blank page.
import React from 'react';

const FLAG = 'fa_error_reload_at';

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { failed: false, message: '' };
  }

  static getDerivedStateFromError(error) {
    return { failed: true, message: String((error && error.message) || error || '').slice(0, 160) };
  }

  componentDidCatch(error, info) {
    console.error('[ErrorBoundary]', error, info && info.componentStack);
    try {
      const last = Number(sessionStorage.getItem(FLAG) || 0);
      if (!last || Date.now() - last > 60000) {
        sessionStorage.setItem(FLAG, String(Date.now()));
        window.location.reload();
      }
    } catch (e) {
      /* storage blocked: just show the message below */
    }
  }

  render() {
    if (!this.state.failed) return this.props.children;
    const box = { maxWidth: 420, margin: '0 auto', padding: '64px 24px', fontFamily: "'Public Sans', system-ui, sans-serif", color: '#1E3A5F' };
    return (
      <div style={{ minHeight: '100vh', background: '#EEF1F3' }}>
        <div style={box}>
          <h1 style={{ fontSize: 24, margin: '0 0 10px' }}>That page didn't load.</h1>
          <p style={{ fontSize: 16, lineHeight: 1.5, color: '#3d4a56', margin: '0 0 22px' }}>
            Your trips and Price Watches are safe. Reload to try again.
          </p>
          <button
            type="button"
            onClick={() => window.location.reload()}
            style={{ width: '100%', padding: '14px 18px', fontWeight: 800, fontSize: 16, background: '#F4C11C', color: '#1a1a1a', border: '2px solid #1E3A5F', cursor: 'pointer' }}
          >
            Reload
          </button>
          <p style={{ fontSize: 12, color: '#5A6B78', margin: '18px 0 0', wordBreak: 'break-word' }}>
            If it keeps happening, email contactus@flyatlast.com. Details: {this.state.message || 'unknown error'}
          </p>
        </div>
      </div>
    );
  }
}
